export { default as Favicons } from './Favicons';
